export const SET_NOTES = "setNewNotes";

export const SET_DIALOG = "setShowDialog";
export const SET_SELECTED_RECTANGLE = "setSelectedRectangle";
